export default {
  name: null,
  credentials: null,
  exchange: null,
  investor_token: null,
  leverage: 1,
  name: null,
};
